import { formatDocument, formatDate } from "../../../../utils";

export function useTopHeaderNotifications() {
  const checkDigitalCertificateExpirationDate = (branch) => {
    if (!branch) {
      return false;
    }
    if (!branch.certificate) {
      return false;
    }
    const validate = new Date(branch.certificate.expiry_date);
    let difference = validate.getTime() - new Date().getTime();
    difference = Math.ceil(difference / (1000 * 3600 * 24));
    let notification = {
      label: "",
      buttonLabel: "Clique aqui para RENOVAR",
      buttonClick: () => {
        const doc = `CNPJ: ${formatDocument(branch.company.cnpj)}`;
        const url = `https://api.whatsapp.com/send?phone=5511966466526&text=Ol%C3%A1,%20sou%20cliente%20Easygestor%20e%20gostaria%20de%20renovar%20meu%20certificado%20digital%20na%20oferta%20especial.%20${doc}`;
        window.location.href = "/digital-certificate";
        window.open(url, "_blank");
      },
    };
    if (difference > 0) {
      if (difference == 1) {
        notification.label = `Atenção! seu certificado digital vence amanhã!`;
      } else if (difference > 0 && difference <= 30) {
        notification.label = `Atenção! Falta(m) ${difference} dias para seu certificado expirar!`;
        return notification;
      } else {
        return false;
      }
    } else {
      notification.label = `Seu certifcado expirou em ${validate.toLocaleString(
        "pt-br"
      )}!`;
      return notification;
    }
  };

  const getNotifications = (branch) => {
    let notifications = [];
    const tamplate = {
      label: "",
      type: "danger",
      buttonLabel: "",
      buttonClick: () => {},
    };
    const certificateExpires = checkDigitalCertificateExpirationDate(branch);
    if (certificateExpires) {
      notifications.push({
        label: certificateExpires.label,
        type: "danger",
        buttonLabel: certificateExpires.buttonLabel,
        buttonClick: certificateExpires.buttonClick,
      });
    }
    if (branch["opened_invoices"]) {
      const opened_invoices = branch["opened_invoices"];
      if (opened_invoices.length) {
        if (window.location.pathname === "/") {
          notifications.push({
            label: `Você possui ${opened_invoices.length} faturas abertas`,
            type: "info",
            buttonLabel: "Clique aqui para visulzar",
            buttonClick: () => {
              window.location.href = "/plan/branch-invoices";
            },
          });
        }
      }
    }
    return notifications;
  };
  return getNotifications;
}



// WEBPACK FOOTER //
// ./src/views/AppViews/TopHeader/hooks/index.js